import { Link } from "react-router-dom";

function HeroPages({ name, name2 }) {
  return (
    <>
      <section className="hero-pages">
        <div className="hero-pages__overlay"></div>
        <div className="container">
          <div className="hero-pages__text">
            <h3>{name}</h3>
            <p>
              <Link to="/">Home</Link> {'>'} {name} {name2 !== undefined ? '> ' + name2 : ''}
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default HeroPages;
